import fiatCurrencies from '@exodus/fiat-currencies';
import { conversionByRate } from '@exodus/currency';
import getQuoteFee from '../utils/get-quote-fee.js';
function toUsd(amount, assetPrices) {
    const convert = conversionByRate(amount.unitType, fiatCurrencies.USD, assetPrices.USD);
    return convert(amount);
}
function getQuoteLosses(params) {
    const { fromAsset, toAsset, quote, prices } = params;
    const fromAssetId = fromAsset.ticker;
    const toAssetId = toAsset.ticker;
    [fromAssetId, toAssetId, fromAsset.feeAsset.ticker].forEach((assetId) => {
        if (!prices[assetId]) {
            throw new Error(`There is no price data for the assets ${assetId}`);
        }
    });
    const feeAmount = getQuoteFee(quote, fromAsset);
    const gasFeeInUsd = toUsd(feeAmount, prices[fromAsset.feeAsset.ticker]);
    const fromAmountInUsd = toUsd(quote.fromAmount, prices[fromAssetId]);
    const toAmountInUsd = toUsd(quote.toAmount, prices[toAssetId]);
    return toAmountInUsd.sub(gasFeeInUsd).sub(fromAmountInUsd).negate();
}
export default getQuoteLosses;
